import React, { useRef, useState } from "react";
import shareIcon from "../../assets/dasboard/share-icon.svg";
import { getColorCode, getImage } from "../../utils/utility-functions";
import ShareProfileModal from "../share-modal/component";

function ShareButton({
  currentAssessmentAttemptData,
  userGUID,
  userData,
  isRomanticCompatibility,
  assessmentAttemptResultId,
  saveUserSocialButtonClickConnect,
  // Opt-in presentation API — every existing caller omits both, so
  // `variant` defaults to "icon" and renders byte-for-byte the same
  // circular icon-only button as before. "pill" is additive only.
  // "outlined" (IQ report CTA) is additive too: CSS-only states, no
  // imperative hover handlers, selected fill while the modal is open.
  variant = "icon",
  label,
}) {
  const [selectedTest, setSelectedTest] = useState(null);

  const [shareModalOpen, setShareModalOpen] = useState(false);
  const buttonRef = useRef(null);
  const currentPersonalityGroup = currentAssessmentAttemptData
    ? currentAssessmentAttemptData?.personality?.role
    : "";

  const personalityColorLight = getColorCode(
    currentPersonalityGroup && currentPersonalityGroup,
  ).light;

  const handleShareReport = (item) => {
    setShareModalOpen(true);
    setSelectedTest(item);
  };

  const isPill = variant === "pill";
  const isOutlined = variant === "outlined";
  const hasLabel = isPill || isOutlined;

  return (
    <div>
      <button
        ref={buttonRef}
        onClick={() => {
          handleShareReport(currentAssessmentAttemptData);
        }}
        onMouseEnter={
          isOutlined
            ? undefined
            : (e) =>
                (e.currentTarget.style.backgroundColor = personalityColorLight)
        }
        onMouseLeave={
          isOutlined
            ? undefined
            : (e) => (e.currentTarget.style.backgroundColor = "transparent")
        }
        {...(isOutlined && {
          "aria-haspopup": "dialog",
          "aria-expanded": shareModalOpen,
          "aria-controls": shareModalOpen ? "share-modal-container" : undefined,
        })}
        className={
          isOutlined
            ? `inline-flex flex-shrink-0 items-center justify-center gap-2 min-h-[44px] px-5 py-2.5 rounded-full border-2 border-solid text-neutral-900 font-semibold text-sm transition-colors active:bg-sky-400/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-neutral-900 ${
                shareModalOpen
                  ? "bg-sky-400/70 border-sky-900"
                  : "bg-transparent border-sky-800 hover:bg-sky-400/40"
              }`
            : isPill
              ? "inline-flex flex-shrink-0 items-center gap-1 sm:gap-2 min-h-[44px] px-1 sm:px-4 py-2.5 rounded-full bg-gray-100 border border-gray-200 text-gray-700 font-medium text-sm hover:bg-gray-200 transition-colors"
              : "aspect-square w-max bg-[#d9d9d9] rounded-full flex items-center justify-center"
        }
      >
        <img
          src={shareIcon}
          alt={isOutlined && label ? "" : "Sharing"}
          className={
            isOutlined
              ? "w-5 h-5 flex-shrink-0"
              : isPill
                ? "w-3.5 h-3.5 sm:w-5 sm:h-5 flex-shrink-0"
                : "w-[40px] h-auto hover:text-insightful-purple"
          }
        />
        {hasLabel && label && <span className="whitespace-nowrap">{label}</span>}
      </button>
      {shareModalOpen && (
        <ShareProfileModal
          isOpen={shareModalOpen}
          onClose={() => {
            setShareModalOpen(false);
            // ShareProfileModal has no focus management of its own; the
            // outlined variant returns focus to its trigger on close.
            if (isOutlined) buttonRef.current?.focus();
          }}
          personalityImage={getImage(
            selectedTest?.personality?.role?.toLowerCase() &&
              selectedTest?.personality?.role?.toLowerCase(),

            selectedTest?.nameEnglishCode?.toLowerCase() &&
              selectedTest?.nameEnglishCode?.toLowerCase(),
            true,
            userData?.gender,
          )}
          assessmentTitle={
            selectedTest?.title || currentAssessmentAttemptData.assessmentTitle
          }
          assessmentId={
            selectedTest?.assessmentId && selectedTest?.assessmentId
          }
          assessmentAttemptId={
            selectedTest?.assessmentAttemptId &&
            selectedTest?.assessmentAttemptId
          }
          personalityType={
            selectedTest?.personality?.title && selectedTest?.personality?.title
          }
          personalityName={
            selectedTest?.personality?.name && selectedTest?.personality?.name
          }
          personalityGroup={
            selectedTest?.personality?.role && selectedTest?.personality?.role
          }
          userGUID={userGUID}
          isRomanticCompatibility={isRomanticCompatibility}
          assessmentAttemptResultId={assessmentAttemptResultId}
          saveUserSocialButtonClickConnect={saveUserSocialButtonClickConnect}
        />
      )}
    </div>
  );
}

export default ShareButton;
